import { render, staticRenderFns } from "./BusinessApplicationPreview.vue?vue&type=template&id=2cb73876&"
import script from "./BusinessApplicationPreview.vue?vue&type=script&lang=js&"
export * from "./BusinessApplicationPreview.vue?vue&type=script&lang=js&"
import style0 from "./BusinessApplicationPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports